var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTenantSettings = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_39)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16375 10.2773C2.918 10.2773 1 10.6168 1 11.9768C1 13.3363 2.90573 13.6886 5.16375 13.6886C7.40949 13.6886 9.32749 13.3486 9.32749 11.9891C9.32749 10.6296 7.42176 10.2773 5.16375 10.2773Z",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16384 8.33745C6.64543 8.33745 7.83256 7.14972 7.83256 5.66872C7.83256 4.18714 6.64543 3 5.16384 3C3.68284 3 2.49512 4.18714 2.49512 5.66872C2.49512 7.14972 3.68284 8.33745 5.16384 8.33745Z",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5594 6.31162L14.3975 6.03067C14.2605 5.79294 13.957 5.71093 13.7189 5.84733C13.6056 5.91409 13.4704 5.93303 13.3431 5.89997C13.2158 5.86692 13.1069 5.78459 13.0403 5.67114C12.9975 5.59903 12.9745 5.5169 12.9737 5.43305C12.9775 5.29861 12.9268 5.16834 12.8331 5.07191C12.7393 4.97547 12.6105 4.92109 12.4761 4.92114H12.1499C12.0181 4.92114 11.8918 4.97364 11.7988 5.06704C11.7059 5.16043 11.654 5.287 11.6546 5.41876C11.6507 5.6908 11.4291 5.90927 11.157 5.90924C11.0732 5.90837 10.991 5.88537 10.9189 5.84257C10.6809 5.70617 10.3773 5.78818 10.2403 6.0259L10.0665 6.31162C9.92974 6.54905 10.0106 6.8524 10.2475 6.99019C10.4015 7.07908 10.4963 7.24336 10.4963 7.42114C10.4963 7.59893 10.4015 7.7632 10.2475 7.85209C10.0109 7.98895 9.92995 8.29157 10.0665 8.52829L10.2308 8.81162C10.295 8.92742 10.4027 9.01287 10.53 9.04907C10.6574 9.08526 10.7939 9.06921 10.9094 9.00448C11.0229 8.93823 11.1582 8.92008 11.2852 8.95406C11.4122 8.98804 11.5203 9.07133 11.5856 9.18543C11.6284 9.25754 11.6514 9.33967 11.6522 9.42352C11.6522 9.69835 11.875 9.92114 12.1499 9.92114H12.4761C12.75 9.92115 12.9724 9.6998 12.9737 9.4259C12.973 9.29373 13.0253 9.16679 13.1187 9.07333C13.2122 8.97987 13.3391 8.92765 13.4713 8.92829C13.5549 8.93052 13.6367 8.95343 13.7094 8.99495C13.9468 9.13176 14.2502 9.05086 14.388 8.814L14.5594 8.52829C14.6257 8.41439 14.644 8.27874 14.61 8.15138C14.576 8.02401 14.4927 7.91545 14.3784 7.84971C14.2642 7.78398 14.1808 7.67541 14.1469 7.54805C14.1129 7.42069 14.1311 7.28504 14.1975 7.17114C14.2406 7.09581 14.3031 7.03334 14.3784 6.99019C14.6139 6.85248 14.6946 6.5509 14.5594 6.314V6.31162Z",
    stroke: "#EC6A4E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3146 8.10702C12.6933 8.10702 13.0003 7.80002 13.0003 7.42131C13.0003 7.0426 12.6933 6.7356 12.3146 6.7356C11.9359 6.7356 11.6289 7.0426 11.6289 7.42131C11.6289 7.80002 11.9359 8.10702 12.3146 8.10702Z",
    stroke: "#EC6A4E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTenantSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tenantSettings.c5412755.svg";
export { ForwardRef as ReactComponent };